module.exports = __webpack_public_path__ + "7d7f23edcf27cd0327623f3c32ca6a3e.png";